import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'
export default class Sapficotemplate extends Component {
 
  render() {
    const course =[
      {
        title: "Introduction to SAP R/3",
     content: [
        "Introduction to ERP Packages",
        "Advantages of SAP over other ERP packages",
        "Introduction to SAP R/3",
        "SAP Landscape",
        "Introduction to FI/CO"
      ]
    },
    {
        title: "Financial Accounting Basic Settings",
     content: [
        "Enterprise Structure",
        "Company",
        "Company Code",
        "Business areas",
        "Chart of Accounts & types of Chart of Accounts",
        "Retained Earnings account",
        "Fiscal Year",
        "Posting Periods",
        "Special Periods",
        "Document types & Number ranges",
        "Field Status Variant",
        "Tolerance group for GL accounts & employees",
        "Posting Keys",
        "Global Parameters"
      ]
    },
    {
        title: "General Ledger",
     content: [
        "Introduction to Master data",
        "GL account Creation, change, display",
        "GL accounts balance display",
        "G/L document postings",
        "Document Display, Changes",
        "Provisions – Accrual/Deferral document",
        "Provisions – Open item management",
        "Full, Partial & Residual clearing",
        "Document holding",
        "Document Parking",
        "Document Reversal",
        "Individual Reversal",
        "Mass Reversal",
        "Cleared Item Reversal",
        "Foreign currency revaluation"
      ]
    },
    {
        title: "Account Payables",
     content: [
        "Vendor Account Group Creation",
        "Vendor Number Range Creation",
        "Assign Number Ranges to vendor accounts",
        "Tolerance group for vendors",
        "Document number ranges",
        "Creation of vendor master data",
        "Reconciliation Account",
        "Purchase invoice posting",
        "Down payments to vendors",
        "Manual payments",
        "Automatic payments",
        "Open Item management",
        "Payment Terms"
      ]
    },
    {
        title: "Account Receivables",
     content: [
        "Customer Account Group Creation",
        "Customer Number Range Creation",
        "Assign number Ranges to Customer accounts",
        "Document Number Ranges",
        "Tolerance Group for Customers",
        "Creation of Customer master data",
        "invoice posting",
        "Payments from Customers",
        "Same customer with vendor",
        "Dunning",
        "Tax on Sales and Purchases"
      ]
    },
    {
        title: "Asset Accounting",
     content: [
        "Chart of Depreciation",
        "Depreciation Areas",
        "Define Asset Class",
        "Depreciation Keys",
        "Creation of Asset Master",
        "Asset Transactions",
        "Asset Acquisition with Vendor",
        "Asset Transfer",
        "Asset Sale",
        "Depreciation Run",
        "Planned depreciation & unplanned depreciation",
        "Display of Asset Balances",
        "Smoothing & catch up methods"
      ]
    },
    {
        title: "Bank Accounting",
     content: [
        "House bank creation",
        "Bank Master data",
        "Main Bank accounts & Bank sub-accounts",
        "Posting of transactions with the Bank",
        "Electronic Bank statement",
        "MT940 file from Bank"
      ]
    },
    {
        title: "Basic Setting for Controlling",
     content: [
        "Introduction to CO Module",
        "FI-CO Integration Scenarios & Rules",
        "Organisational Structure",
        "Maintain Controlling Area",
        "Maintain Controlling Number Ranges",
        "Maintain Versions"
      ]
    },
    {
        title: "Cost Element Accounting",
     content: [
        "Types of cost elements",
        "Manual Creation of Primary, Secondary Cost Elements",
        "Primary, Secondary cost element categories",
        "Automatic Creation of Cost Elements",
        "Creation of Cost Element Groups"
      ]
    },
    {
        title: "Cost Center Accounting",
     content: [
        "Creation of Cost Center",
        "Define Cost Center Group",
        "Cost Center Standard Hierarchy",
        "Posting to the Cost Center",
        "Display CO Document",
        "Display Actual Line Items",
        "Open & Close Controlling periods"
      ]
    },
    {
        title: "Internal Orders",
     content: [
        "Activate Order Management in CO",
        "Maintain Settlement Profile, Number Ranges for Settlement Documents",
        "Maintain Allocation Structure",
        "Define Order Type",
        "Number Ranges for Orders",
        "Creation of Internal Orders",
        "Define Settlement Rule in Order Master Data",
        "Posting of Values – Statistical and Real",
        "Settlement of order",
        "Planning"
      ]
    },
    {
        title: "Profit Center Accounting",
     content: [
        "Dummy Profit Center",
        "Creation of Profit centers",
        "Assign Cost Center to Profit Center",
        "Automatic Account Assignment of Revenue Elements",
        "Number Ranges for Documents",
        "Posting – Revenue and Expenses",
        "Planning"
      ]
    },
    {
        title: "Integration with Other Modules",
     content: [
        "FI-MM Integration",
        "FI-SD Integration"
      ]
    }
    ]

 
    const faqData = [
      {
        question: 'What is SAP FICO Training?',
        answer:
          'SAP FICO Training is a specialized program designed to provide individuals with the skills and knowledge required to work with SAP\'s Financial Accounting (FI) and Controlling (CO) modules',
      },
      {
        question: 'Why is SAP FICO Training important?',
        answer:
          'SAP FICO Training is essential for professionals seeking to manage financial transactions, generate financial reports, and perform cost accounting within organizations using SAP ERP systems',
      },
      {
        question: 'Who can benefit from SAP FICO Training at the best training centre?',
        answer:
          'SAP FICO Training at the best training centre is suitable for finance professionals, accountants, business analysts, and anyone interested in pursuing a career in SAP financial management',
      },
      {
        question: `What career opportunities are available for someone with ${this.props.title} skills?`,
        answer:
          'A person with SAP FICO skills can pursue various career paths, such as SAP FICO Consultant, Financial Analyst, Financial Controller, Finance Manager, and SAP Business Analyst',
      },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume',
      },
    ];
    const EligibilityData=[
      {
        cnt:"Embark on a transformative journey into SAP FICO at the Best Training Centre. Our comprehensive SAP FICO training program welcomes learners from diverse backgrounds, regardless of prior accounting or finance experience. Whether you're a finance professional aiming to enhance your skills or a beginner eager to delve into financial management software, our courses cater to individuals at every proficiency level. With a focus on practical application and hands-on learning, our expert instructors guide you through essential SAP FICO concepts, including financial accounting, controlling, asset accounting, and integration with other SAP modules. At the Best Training Centre, we prioritize accessibility and inclusivity, ensuring that all learners have the opportunity to excel in mastering SAP FICO. Join us and unlock your financial expertise with the best training centre"
      },
    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Jayalakshmi",
          date:" Feb 19 ,2023",
          review:` SAP FICO training in ${this.props.location} is a stepping stone to a prosperous career in financial management. With the growing demand for SAP FICO professionals, this training offers specialized knowledge, hands-on experience, and the potential for career advancement. If you aspire to excel in the financial world, consider SAP FICO training as your gateway to financial excellence.`
      },
      { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Anwar",
          date:" Feb 27 ,2023",
          review:"SAP FICO training covers a wide range of topics, including financial accounting basics, asset accounting, accounts payable, accounts receivable, and controlling. You'll acquire a comprehensive skillset that's in high demand."
      },
  ]
    return(
      <>
       
          {/* <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro='In the dynamic realm of financial management, precision and integration are the bedrock of success. Enter SAP FICO, an acronym denoting "Financial Accounting" (FI) and "Controlling" (CO) within SAP. It stands as the cornerstone of comprehensive financial management modules within the SAP ERP system. Developed with meticulous care, SAP FICO is engineered to bolster financial and accounting activities across organizations. '/> */}
            
          <NewMainsec rating='4.2' students={"230"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro='In the dynamic realm of financial management, precision and integration are the bedrock of success. Enter SAP FICO, an acronym denoting "Financial Accounting" (FI) and "Controlling" (CO) within SAP. It stands as the cornerstone of comprehensive financial management modules within the SAP ERP system. Developed with meticulous care, SAP FICO is engineered to bolster financial and accounting activities across organizations. '/>

            
            <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
		        <Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`SAP Financial Accounting and Controlling (FICO) Training is a comprehensive course designed to provide participants with the knowledge and skills to effectively manage financial accounting and controlling processes using the SAP FICO module. SAP FICO is a critical component of the SAP ERP system, dedicated to managing financial transactions, financial reporting, and cost controlling. This training aims to equip learners with the expertise to configure, customize, and optimize the SAP FICO module, ensuring accurate financial management and controlling within an organization.`} 
            title={this.props.title} location={this.props.location} location1={this.props.location1} course={`Our SAP FICO course covers financial accounting and controlling processes in SAP. Topics include general ledger accounting, accounts payable and receivable, asset accounting, cost element accounting, cost center accounting, and profitability analysis. Our experienced trainers will guide you through hands-on exercises and real-world scenarios to help you understand the concepts and techniques used in SAP FICO. By the end of the course, you will be able to implement SAP FICO practices in your own projects.`}/>
		      </section>
          <Batchtime title={this.props.title} fees="39,999" offer="34,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
 <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>
        <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1} cou2="SAP BASIS" coupath2="sap-basis" cou='SAP ABAP' coupath='sap-abap' cou9='SAP SD' coupath9='sap-sd' cou6='SAP MM' coupath6='sap-mm' cou10='SAP BI' coupath10='sap-bi'
          cou5='SAP MDG' coupath5='sap-mdg' cou3='SAP FIORI' coupath3='sap-fiori' cou7='SAP HR' coupath7='sap-hr'
          cou1='SAP SCM' coupath1='sap-scm' cou8='SAP PP' coupath8='sap-pp'  cou4='SAP S4 HANA' coupath4='sap-s4-hana' />

        
      </>
    );
  }
}
